import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state/store";

export interface LoaderState {
  isLoading: boolean;
}

const initialState: LoaderState = {
  isLoading: false,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.isLoading = true;
    },
    hideLoader: (state) => {
      state.isLoading = false;
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;

export const selectLoaderState = (state: RootState) => state.loader.isLoading;

export default loaderSlice.reducer;
